<div class="newletter_area overlay ">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="col-lg-12">
                <div class="row align-items-center">
                    <!-- <div class="box3"></div> -->
                     <div class="col-lg-12 mb-3"> 
                        <h3>What Our Customers Say</h3> 
                     </div>
                 
                    <div class="col-lg-12 mb-5">                     
                        <!-- Spinner untuk elfsight #1 -->
                        <div *ngIf="isLoading[0]" class="spinner-backdrop" [class.fade-out]="isLoadingDone[0]">
                            <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <div #elfsightApp class="elfsight-app-74eb065e-4895-43b9-a927-d29227d69d63" data-elfsight-app-lazy></div>              
                    </div>
                    
                    <div class="col-lg-12 mb-5"><hr/></div>
                
                    <div class="col-lg-12 mb-5">
                        <!-- Spinner untuk elfsight #2 -->
                        <div *ngIf="isLoading[1]" class="spinner-backdrop" [class.fade-out]="isLoadingDone[1]">
                            <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <div #elfsightApp class="elfsight-app-7033b9d6-834c-420e-9ef1-b731850929e7" data-elfsight-app-lazy></div>
                    </div>
    
                </div>
            </div>
        </div>
    </div>
</div>
